export var isHexStrict = function (hex) {
    return typeof hex === "string" && /^((-)?0x[0-9a-f]+|(0x))$/i.test(hex);
};
//# sourceMappingURL=string.js.map